<a (click)="filterClients('new')" [routerLink]="[currentLang,'clients']" [queryParams]="{ filter: 'new' }" [class.active]="currentFilter=='new'">
    {{"MENU.CLIENTS.NEW" | translate }}</a>
<a (click)="filterClients('archive')" [routerLink]="[currentLang,'clients']" [queryParams]="{ filter: 'archive' }"
   [class.active]="currentFilter=='archive'">
    {{ "MENU.CLIENTS.ARCHIVE" | translate }}
</a>
